import comp from "./FieldCardsV2";
export default comp;
